/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';

var StoreAltIcon = createIcon({
  name: 'StoreAltIcon',
  height: 512,
  width: 640,
  svgPath: 'M320 384H128V224H64v256c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V224h-64v160zm314.6-241.8l-85.3-128c-6-8.9-16-14.2-26.7-14.2H117.4c-10.7 0-20.7 5.3-26.6 14.2l-85.3 128c-14.2 21.3 1 49.8 26.6 49.8H608c25.5 0 40.7-28.5 26.6-49.8zM512 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h-64v272z',
  yOffset: '',
  xOffset: '',
  transform: ''
});

export default StoreAltIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-icons/dist/esm/icons/store-alt-icon.js
// module id = 973
// module chunks = 0